<template>
  <div class="worksDeclare">
    <childLogo v-if="workId==null"></childLogo>
    <div class="navbar-dark">
      <div class="container">
        <div v-if="workId==null">
          <div class="sigma-content">
            <div class="sigma-middle-line">
              <span class="sigma-line-text">作品申报</span>
            </div>
          </div>
          <div
            style="font-size: 21px;margin: 15px;color: #5e5e5e;text-align: center;"
          >全国青年科普创新实验暨作品大赛</div>
        </div>
        <div class="sign-up-form-input">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="180px" :label-position="lablePosition">
            <el-form-item label="赛题组" prop="topicId" >
              <el-select v-model="ruleForm.worksType" placeholder="请选择赛题组" @change="chooseSelect" :disabled="submitted">
                <el-option label="智能控制-大学组" :value="1" aria-selected></el-option>
                <el-option label="智能控制-中学组" :value="2"></el-option>
                <el-option label="未来教育-大学组" :value="3"></el-option>
                <el-option label="生物环境-大学组" :value="4"></el-option>
                <el-option label="风能利用-中学组" :value="5"></el-option>
              </el-select>
            </el-form-item>
            <component :is="currentView" :selectData="ruleForm"></component>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";
import IntelligentUniversityGroup from "@/views/worksDeclare/IntelligentUniversityGroup.vue";
import IntelligentMiddleSchoolGroup from "@/views/worksDeclare/IntelligentMiddleSchoolGroup.vue";
import EducationUniversityGroup from "@/views/worksDeclare/EducationUniversityGroup.vue";
import BiologyUniversityGroup from "@/views/worksDeclare/BiologyUniversityGroup.vue";
import WindEnergyMiddleSchoolGroup from "@/views/worksDeclare/WindEnergyMiddleSchoolGroup.vue";
import {getParticipantData} from '@/api/info/index';

export default {
  components: {
    ChildLogo,
    IntelligentUniversityGroup,
    IntelligentMiddleSchoolGroup,
    EducationUniversityGroup,
    BiologyUniversityGroup,
    WindEnergyMiddleSchoolGroup
  },
  props: ["workId","submitted"],
  data() {
    return {
      ruleForm: {
        worksType: 1,
        worksName: "",
        brief: "",
        remark: "",
        participantId: "",
        siteId: this.siteId
      },
      user: this.$store.state.user,
      rules: {
        topicId: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      },
      currentView: "IntelligentUniversityGroup",
      lablePosition: "right",
    };
  },
  beforeMount() {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (mobile) {
      this.lablePosition = "top";
    }
  },
  created() {
    if (this.workId) {
      // 查询数据
      this.getContParticipant();
    } else {
      this.getParticipantId();
      this.ruleForm.remark = this.generateUUID();
    }
  },
  methods: {
    chooseSelect() {
      switch (this.ruleForm.worksType + "") {
        case "1":
          this.currentView = "IntelligentUniversityGroup";
          break;
        case "2":
          this.currentView = "IntelligentMiddleSchoolGroup";
          break;
        case "3":
          this.currentView = "EducationUniversityGroup";
          break;
        case "4":
          this.currentView = "BiologyUniversityGroup";
          break;
        case "5":
          this.currentView = "WindEnergyMiddleSchoolGroup";
          break;
        default:
          break;
      }
    },
    generateUUID() {
      var mydate = new Date();
      var uuid =
        mydate.getDay() +
        mydate.getHours() +
        mydate.getMinutes() +
        mydate.getSeconds() +
        mydate.getMilliseconds() +
        Math.round(Math.random() * 10000);
      var rid = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      return uuid + new Date().getTime() + rid;
    },
    getParticipantId() {
      getParticipantData(this.baseURL,{userId:this.user.userId,siteId:this.siteId}).then(res => {
        // 如果参赛
        if (res.rows.length == 1 && res.rows[0].id) {
          this.ruleForm.participantId = res.rows[0].id;
          this.ruleForm.siteId = this.siteId;
        } else {
          this.uploadDisabled = true;
          this.$alert("请先报名参赛！", "提示", {
            confirmButtonText: "确定",
            type: "warning",
            showClose: false
          })
            .then(() => {
              this.$parent.pageShow = false;
              // this.$router.replace("/myHome");
              this.$router.go(0);
            })
            .catch(() => {});
        }
      });
    },
    async getContParticipant() {
      var id = null;
      if (this.workId) {
        id = this.workId;
      } else {
        this.$store.commit("loginVisibleMutations", true);
        return;
      }
      // 获取input信息
      var workApi = this.baseURL + `/actuator/works/${id}`;
      await this.axios.get(workApi, {}).then(res => {
        console.log("查看详情", res);
        this.ruleForm = res.data.data;
        this.chooseSelect();
      });
    }
  }
};
</script>

<style scoped>
.sign-up-form-input {
  margin-top: 50px;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0c70fc; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}

.worksDeclare .el-form-item__content {
  width: 100%;
}

.worksDeclare .el-form-item__content .el-select {
  width: 100%;
}

.worksDeclare .el-form-item__content .el-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/WorksDeclare.vue